import { useLottiePlayer } from '@starsoft/common/hooks';
import { TransWithDefault } from '../TransWithDefault';
import { EmptySearchProps } from './props';
import styles from './styles.module.scss';

/**
 * EmptySearch Component
 * Renders an empty state with a Lottie animation and translated text message
 * Used to display when search results are empty or no results exist
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.search - Search term that yielded no results
 * @returns {JSX.Element} Empty state with animation and message
 */
export default function EmptySearch({ search }: EmptySearchProps) {
  // Initialize Lottie animation player with empty search animation
  const { lottieAnimationRef } = useLottiePlayer({
    path: '/empty-search.json',
  });

  return (
    <div className={styles.container}>
      {/* Container for Lottie animation */}
      <div className={styles.container__lottie} ref={lottieAnimationRef} />

      {/* Display translated message based on whether search term exists */}
      <p className={styles.container__text}>
        <TransWithDefault
          i18nKey={search ? 'common:not_found_description' : 'common:no_result'}
          values={{
            search: search,
          }}
        />
      </p>
    </div>
  );
}
